import './config.js'; //Global configuration object
import React, { Component } from 'react';
import Header from './components/header.js';
import Footer from './components/footer.js';
import './App.css';
import LandingPage from './components/landing-page.js';
import AdminLandingPage from './components/adminlanding-page.js';
import AdminPage from './components/admin-page.js';
import LesseePage from './components/lessee-page.js';
import ContactusPage from './components/contactus-page.js';
import FaqPage from './components/faq-page.js';
import PrivacyPage from './components/privacy-page.js';

class App extends Component {

	constructor(props){
		super(props)

		var l = window.location;

		var isLoggedIn = false;
		var isAdminLoggedIn = false;
		//console.log("window.location='" + l.href + "'");
		//console.log("window.pathname='" + l.pathname + "'");
		
		// +++ setup back-end services location +++
		var host="/services/api/";					//PRD
		if (l.href.match(/localhost:3000/gi)){
			host = "http://localhost:51749/api/";	//DEV
			//host = "http://localhost/LMITSFileUploadBE/api/";

		} else if (l.href.match(/LMITSFileUpload/gi)){
			host = "/LMITSFileUpload/services/api/";	//TST
		}
		window.AppConfig = {
			"url-upload" : host + "File",
			"url-l10n" : host + "GetLocalizations",
			"url-authenticate" : host + "Login",
			"url-logout" : host + "Logout",	
			"url-lesseedetails" : host + "GetLesseeDetails",
			"url-contactus" : host + "Email",
			"url-keepalive" : host + "KeepAlive"
		};
		// --- setup back-end services location ---

		// +++ Locale detection +++
		//set default based on host
		if (l.href.match(/dossier/gi)){
			window.locale = "FR"
		} else {
			window.locale = "EN"
		}

		//override locale based on url
		if (l.pathname.match(/-EN/gi)){
			window.locale = "EN";
		} else if (l.pathname.match(/-FR/gi)){
			window.locale = "FR";
		}

		document.title = window.l10n[window.locale]["application.title"];
		// --- Locale detection ---

		this.bindKeepAlive();
		var navPage;

		//+++ Admin user detection +++
		window.optaToken = "";
		window.optaAdminToken = "";
		var optaAdminToken = l.href.match(/\?oa=.*$/);
		if (optaAdminToken) {
			var strOptaAdminToken = optaAdminToken[0].substr(4);
			//console.log("opta admin token is '" + strOptaAdminToken + "'");
			window.optaAdminToken = strOptaAdminToken;
			isAdminLoggedIn = true;
		}
		//--- Admin user detection ---

		//+++ Routing +++
		var optaToken = l.href.match(/\?ol=.*$/);
		if (optaToken) {
			var strOptaToken = optaToken[0].substr(4);
			//console.log("opta token is '" + strOptaToken + "'");
			window.optaToken = strOptaToken;
			isLoggedIn = true;
		}

		if (l.pathname.match(/.*\/landing/gi)){
			if (optaAdminToken) {
				navPage = <AdminLandingPage ctx={this} ref={ landingPage => this.landingPage = landingPage}/>;
			} else {
				navPage = <LandingPage ctx={this} ref={ landingPage => this.landingPage = landingPage}/>;
			}
			//console.log("navpage is LandingPage");
		} else if (l.pathname.match(/\/faqs/gi)){
			navPage = <FaqPage />;
			//console.log("navpage is faqPage");
			window.keepAlive();
		} else if (l.pathname.match(/\/privacy/gi)){
			navPage = <PrivacyPage />;
			//console.log("navpage is PrivacyPage");
			window.keepAlive();
		} else if (l.pathname.match(/\/contactus/gi)){
			navPage = <ContactusPage/>;
			//console.log("navpage is ContactusPage");
		} else if (l.pathname.match(/\/lessee/gi)){
			//console.log("navpage is almost LesseePage");
			if (!optaAdminToken) {
				if (isLoggedIn) {
					navPage = <LesseePage/>;
					//console.log("navpage IS LesseePage");
				}
			}
		} else if (l.pathname.match(/\/admin/gi)){
			if (!isAdminLoggedIn){
				navPage = <AdminLandingPage ctx={this} ref={ landingPage => this.landingPage = landingPage}/>;
			} else {
				navPage = <AdminPage ctx={this} />;
			}
		}

		if (!navPage) {
			//console.log("!navPage");
			/*if (!optaAdminToken) {
				//console.log("!navPage 1");
				navPage = <LandingPage ctx={this} 
					ref={ landingPage => this.landingPage = landingPage}
				/>;
			} else {
				//console.log("!navPage 2");
				navPage = <AdminLandingPage ctx={this}
					ref={ landingPage  => this.landingPage = landingPage}
				/>;
			}*/
			//console.log("!navPage 3");
			//console.log("hostingEnvironment='" + hostingEnvironment + "'");
			window.location.href = "landing-"+window.locale;
		}
		//--- Routing ---

		this.state = {isLoggedIn: isLoggedIn, isAdminLoggedIn: isAdminLoggedIn, navPage: navPage};
	}

	bindKeepAlive(){
		window.keepAlive = function(){
			var theToken = "";
			var urlFailPage = "";
			if (window.optaToken !== ''){
				theToken = window.optaToken;
				urlFailPage = "landing-";
			} else if (window.optaAdminToken !== '' ){
				theToken = window.optaAdminToken;
				urlFailPage = "admin-";
			}
			if (theToken === "") return false;

			var xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function () {
				if (this.readyState === 4) {
					if (this.status === 200) {
						//console.log("Keep Alive successful!");
					} else {
						//go to login page
						var pathName = urlFailPage + window.locale;
						//console.log("KeepAlive failed: Going to login page: '" + pathName + "'");
						window.optatoken = "";
						window.optaAdmintoken = "";
						window.location.href = pathName;
					}
				}
			};

			xhr.open('post', window.AppConfig["url-keepalive"], true);
			var formData = new FormData();
			formData.append("optatoken", theToken);

			try {
				xhr.send(formData);
			} catch (e) {
				//console.log("Failed to KeepAlive:" + e);
			}
		}
	}

	doLocaleChanged(){
		//console.log("App - LocaleChanged " + window.locale);
		this.setState({});
		this.forceUpdate();
	}

	getLocalizationsFromServer(){
		var xhr = new XMLHttpRequest();
		xhr.open('get', window.AppConfig["url-l10n"], true);

		var t = this;
		xhr.onreadystatechange = function() {
			if (this.readyState === 4)
			{
				if (this.status === 200) {
					//console.log("App.js: getLocalizationsFromServer()");
					if (this.responseText){
						var responseJson = [];
						try{
							responseJson= JSON.parse(this.responseText);
						} catch (e) {
							return false;
						}
						var isDirty = false;
						//console.log("L10n: %o", responseJson);
						responseJson.forEach( function(l){
							if (!window.l10n[l.locale]) window.l10n[l.locale] = {};
							if (window.l10n[l.locale][l.langkey] !== l.langtext){
								window.l10n[l.locale][l.langkey] = l.langtext;
								isDirty = true;
							}
						});
						if (isDirty) t.setState({});
						if (window.l10n[window.locale]["welcome.message"] && window.l10n[window.locale]["welcome.message"].length > 0)
						{
							//console.log("detected Scheduled Outage message. t=%o", t);
							if (t.landingPage) t.landingPage.scheduledOutage();
						}
					}
				} else /*if (this.status === 504)*/ {
					console.log("Database unavailable. navPage=%o", t.state.navPage);
					console.log("response.status=%o", this.status);
					if (t.landingPage) t.landingPage.unscheduledOutage();					
				}
			}
		};

		try{
			xhr.send();
		} catch (e) {
			//console.log("Failed to download updated l10n:" + e);
		}
	}
	componentDidMount() {
		this.getLocalizationsFromServer();
	}

	render() {
		return (
		  <div className="App">
			<Header ctx={this} />
			{this.state.navPage}
			{ (this.state.isLoggedIn || this.state.isAdminLoggedIn)? '' : <Footer />}
		</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js